// Owner-supplied M1 PRO product video shown on the homepage ("See it in action").
export const productVideo = {
  src: 'https://cdn.magicpatterns.com/uploads/7a1efrFm171q5ZAz8ChxTH/1340913d-a2d2-4cd8-b454-9c8c25e0d465.mp4',
  title: 'M1 PRO in action',
  description: 'Installed MarineForceLED M1 PRO lights switching on in different pools and homes at night.',
};
